import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { Toaster } from './toaster';

const ToasterContext = createContext();

export function ToasterProvider({ children }) {
    const [toast, setToast] = useState(null);

    const showToast = useCallback((message, type = "s", duration = 6000) => {
        setToast({ message, type, duration });
    }, []);

    const handleClose = useCallback(() => {
        setToast(null);
    }, []);

    const contextValue = useMemo(() => ({ showToast }), [showToast]);

    return (
        <ToasterContext.Provider value={contextValue}>
            {children}
            {toast && <Toaster {...toast} handleClose={handleClose} />}
        </ToasterContext.Provider>
    );
}

export function useToaster() {
    return useContext(ToasterContext);
}
